import type { IconData } from '@stacksjs/iconify-core'

export const shoppingBagF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 8V5a5 5 0 1 1 10 0v3h2a3 3 0 0 1 3 3v3a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-3a3 3 0 0 1 3-3zm2 0h6V5a3 3 0 0 0-6 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingBagF
